import { Box, Flex } from '@chakra-ui/react'
import { Partogram } from '../Partogram'

export const GraphsTab = () => (
  <Flex flexFlow="column" alignItems="center" overflowY="auto" overflowX="hidden" w="100%" h="100%">
    <Box w="100%">
      <Partogram />
    </Box>
  </Flex>
)
